<template>
  <div
    v-show="$route.params.action == 'create'"
    class="flex flex-col items-start"
  >
    <item-display
      :item.sync="item"
      :disabled="disabled"
    />

    <div class="my-10" v-if="disabled">
      Loading...
    </div>

    <general-button
      @button-click="$emit('add-item')"
      :disabled="disabled"
      text="Create Item"
      color="green"
    />
  </div>
</template>

<script>

import ItemDisplay from './ItemDisplay.vue';
import GeneralButton from './GeneralButton.vue';

export default {
  name: 'add-section',
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ItemDisplay,
    GeneralButton,
  },
};
</script>
